export { default as Skeleton } from './Skeleton';
export type { SkeletonProps, SkeletonTextProps } from './types';
